/**
 * A & M Keepsakes - Theme Interactions JavaScript
 * Coordinates Mobile Navigation, Interactive Book Hotspots, and AJAX Cart Drawer actions.
 */

(function () {
  'use strict';

  // Safely initialize the global theme object if undefined
  window.theme = window.theme || {};

  // Format price helper using Shopify store settings or default AUD formatting
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = window.theme.moneyFormat || '${{amount}}';

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  // --- MOBILE MENU ---
  const menuToggle = document.getElementById('MenuToggle');
  const mobileMenu = document.getElementById('MobileMenu');
  const menuIconOpen = document.getElementById('MenuIconOpen');
  const menuIconClose = document.getElementById('MenuIconClose');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      const isOpen = !mobileMenu.classList.contains('hidden');
      if (isOpen) {
        mobileMenu.classList.add('hidden');
        menuIconOpen.classList.remove('hidden');
        menuIconClose.classList.add('hidden');
      } else {
        mobileMenu.classList.remove('hidden');
        menuIconOpen.classList.add('hidden');
        menuIconClose.classList.remove('hidden');
      }
    });
  }

  // --- HOTSPOT TOOLTIPS ---
  const hotspots = document.querySelectorAll('.hotspot-container');
  hotspots.forEach(container => {
    const trigger = container.querySelector('.hotspot-trigger');
    const tooltip = container.querySelector('.hotspot-tooltip');

    if (!trigger || !tooltip) return;

    const showTooltip = () => {
      tooltip.style.left = '50%';
      tooltip.style.right = 'auto';
      tooltip.style.transform = 'translateX(-50%)';

      tooltip.classList.remove('opacity-0', 'pointer-events-none');
      tooltip.classList.add('opacity-100', 'pointer-events-auto');

      const rect = tooltip.getBoundingClientRect();
      const viewportWidth = window.innerWidth;

      if (rect.left < 16) {
        tooltip.style.left = '0%';
        tooltip.style.transform = 'translateX(0)';
      } else if (rect.right > viewportWidth - 16) {
        tooltip.style.left = 'auto';
        tooltip.style.right = '0%';
        tooltip.style.transform = 'translateX(0)';
      }
    };

    const hideTooltip = () => {
      tooltip.classList.remove('opacity-100', 'pointer-events-auto');
      tooltip.classList.add('opacity-0', 'pointer-events-none');
    };

    // Desktop hover events
    trigger.addEventListener('mouseenter', showTooltip);
    trigger.addEventListener('mouseleave', hideTooltip);

    // Mobile click behavior (prevent mouseleave firing first)
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      const isActive = tooltip.classList.contains('opacity-100');

      // Close all other tooltips first
      document.querySelectorAll('.hotspot-tooltip').forEach(el => {
        el.classList.add('opacity-0', 'pointer-events-none');
        el.classList.remove('opacity-100', 'pointer-events-auto');
      });

      if (!isActive) {
        showTooltip();
      }
    });
  });

  // Close open tooltips when clicking anywhere else
  document.addEventListener('click', function () {
    document.querySelectorAll('.hotspot-tooltip').forEach(el => {
      el.classList.add('opacity-0', 'pointer-events-none');
      el.classList.remove('opacity-100', 'pointer-events-auto');
    });
  });

  // --- CART DRAWER & AJAX ACTIONS ---
  const cartDrawer = document.getElementById('CartDrawer');
  const cartOverlay = document.getElementById('CartOverlay');
  const cartCloseBtn = document.getElementById('CartCloseBtn');
  const openCartBtns = document.querySelectorAll('[data-open-cart]');
  const cartCountBadges = document.querySelectorAll('.cart-count-badge');

  function openCart() {
    if (cartDrawer) {
      cartDrawer.classList.remove('translate-x-full');
      cartDrawer.classList.add('translate-x-0');
    }
    if (cartOverlay) {
      cartOverlay.classList.remove('opacity-0', 'pointer-events-none');
      cartOverlay.classList.add('opacity-100');
    }
  }

  function closeCart() {
    if (cartDrawer) {
      cartDrawer.classList.remove('translate-x-0');
      cartDrawer.classList.add('translate-x-full');
    }
    if (cartOverlay) {
      cartOverlay.classList.remove('opacity-100');
      cartOverlay.classList.add('opacity-0', 'pointer-events-none');
    }
  }

  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  openCartBtns.forEach(btn => btn.addEventListener('click', openCart));

  // Refresh cart contents asynchronously
  async function refreshCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      window.theme.cart = cart;
      
      // Update count badges
      cartCountBadges.forEach(badge => {
        badge.textContent = cart.item_count;
        if (cart.item_count > 0) {
          badge.classList.remove('hidden');
        } else {
          badge.classList.add('hidden');
        }
      });

      const drawerContentContainer = document.getElementById('CartDrawerContent');
      if (!drawerContentContainer) return;

      if (cart.item_count === 0) {
        drawerContentContainer.innerHTML = `
          <div class="flex-1 flex flex-col items-center justify-center px-8 text-center gap-3 h-[60vh]">
            <svg class="w-10 h-10 text-[#A3B18A]" fill="none" stroke="currentColor" stroke-width="1.2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
            </svg>
            <button id="CartContinueBrowsing" class="mt-2 px-5 py-2.5 rounded-full bg-[#4A5D4E] text-[#FAF9F6] text-[13px] hover:bg-[#8B5E5E] transition-colors">
              Browse the Library
            </button>
          </div>
        `;
        document.getElementById('CartContinueBrowsing')?.addEventListener('click', closeCart);
        
        // Hide subtotal container if empty
        const footerContainer = document.getElementById('CartDrawerFooter');
        if (footerContainer) footerContainer.classList.add('hidden');
      } else {
        // Render items list
        let itemsHtml = '<div class="flex-1 overflow-y-auto px-6 py-5 space-y-5">';
        cart.items.forEach((item, index) => {
          const lineNum = index + 1;
          const personalization = item.properties && item.properties.Personalization ? item.properties.Personalization : '';

          itemsHtml += `
            <div class="flex gap-4 pb-5 border-b border-[#EDE8DC] last:border-0" data-key="${item.key}">
              <img src="${item.image}" alt="${item.product_title}" class="w-20 h-24 object-cover rounded-sm shadow-natural" />
              <div class="flex-1 min-w-0">
                <div class="flex justify-between gap-2">
                  <h3 class="font-display text-lg text-[#4A5D4E] leading-tight">${item.product_title}</h3>
                  <button class="text-[#A3B18A] hover:text-[#8B5E5E] cart-remove-item" data-key="${item.key}">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
                </div>
                ${personalization ? `<p class="text-[12px] text-[#8B5E5E] italic mt-0.5">Embossed: “${personalization}”</p>` : ''}
                
                <div class="flex items-center justify-between mt-3">
                  <div class="flex items-center border border-[#D9D2C3] rounded-full">
                    <button class="px-2.5 py-1 text-[#4A5D4E] hover:text-[#8B5E5E] cart-qty-minus" data-key="${item.key}" data-qty="${item.quantity}">
                      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6" />
                      </svg>
                    </button>
                    <span class="px-2 text-[13px] w-6 text-center">${item.quantity}</span>
                    <button class="px-2.5 py-1 text-[#4A5D4E] hover:text-[#8B5E5E] cart-qty-plus" data-key="${item.key}" data-qty="${item.quantity}">
                      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
                      </svg>
                    </button>
                  </div>
                  <span class="text-[14px] font-medium text-[#4A5D4E]">${formatMoney(item.final_line_price)}</span>
                </div>
              </div>
            </div>
          `;
        });
        itemsHtml += '</div>';
        drawerContentContainer.innerHTML = itemsHtml;

        // Render subtotal price and show footer
        const subtotalEl = document.getElementById('CartDrawerSubtotal');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        
        const footerContainer = document.getElementById('CartDrawerFooter');
        if (footerContainer) footerContainer.classList.remove('hidden');

        // Bind update events to elements
        bindDrawerItemEvents();
      }
    } catch (err) {
      console.error('Failed to refresh cart:', err);
    }
  }

  // Bind cart item actions
  function bindDrawerItemEvents() {
    // Continue browsing / close cart actions
    const continueBtn = document.getElementById('CartContinueBrowsing');
    if (continueBtn) {
      continueBtn.addEventListener('click', closeCart);
    }
    const drawerContinueBtn = document.getElementById('CartDrawerContinueBtn');
    if (drawerContinueBtn) {
      drawerContinueBtn.addEventListener('click', closeCart);
    }

    // Quantity minus
    document.querySelectorAll('.cart-qty-minus').forEach(btn => {
      btn.addEventListener('click', async function () {
        const key = this.getAttribute('data-key');
        const currentQty = parseInt(this.getAttribute('data-qty'), 10);
        if (currentQty <= 1) return;
        await changeQuantity(key, currentQty - 1);
      });
    });
 
    // Quantity plus
    document.querySelectorAll('.cart-qty-plus').forEach(btn => {
      btn.addEventListener('click', async function () {
        const key = this.getAttribute('data-key');
        const currentQty = parseInt(this.getAttribute('data-qty'), 10);
        await changeQuantity(key, currentQty + 1);
      });
    });
 
    // Remove item
    document.querySelectorAll('.cart-remove-item').forEach(btn => {
      btn.addEventListener('click', async function () {
        const key = this.getAttribute('data-key');
        await changeQuantity(key, 0);
      });
    });
 
    // Debounced gift note saves
    let noteTimeout;
    document.querySelectorAll('.cart-gift-note-input').forEach(input => {
      input.addEventListener('input', function () {
        clearTimeout(noteTimeout);
        const key = this.getAttribute('data-key');
        const giftNoteValue = this.value;
        
        noteTimeout = setTimeout(async () => {
          await updateGiftNote(key, giftNoteValue);
        }, 800);
      });
    });
  }

  // Update quantity on cart line item key
  async function changeQuantity(id, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: new URLSearchParams({
          id: id,
          quantity: quantity.toString()
        })
      });
      if (response.ok) {
        await refreshCart();
      } else {
        const errText = await response.text();
        console.error('changeQuantity failed:', response.status, errText);
      }
    } catch (error) {
      console.error('Error changing quantity:', error);
    }
  }

  // Update gift note property on cart line item key
  async function updateGiftNote(id, note) {
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      const currentItem = cart.items.find(item => item.key === id);
      if (!currentItem) return;

      const updatedProperties = Object.assign({}, currentItem.properties || {});
      updatedProperties['Gift Note'] = note;

      const bodyParams = new URLSearchParams();
      bodyParams.append('id', id);
      for (const [key, val] of Object.entries(updatedProperties)) {
        bodyParams.append(`properties[${key}]`, val);
      }

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: bodyParams
      });
      
      if (response.ok) {
        window.theme.cart = await response.json();
      } else {
        const errText = await response.text();
        console.error('updateGiftNote failed:', response.status, errText);
      }
    } catch (error) {
      console.error('Error updating gift note:', error);
    }
  }

  // Global APIs for theme actions
  window.theme.openCartDrawer = openCart;
  window.theme.closeCartDrawer = closeCart;
  window.theme.refreshCartDrawer = refreshCart;

  // Add Product Form Ajax integration
  window.theme.addProductToCart = async function (formElement) {
    try {
      const formData = new FormData(formElement);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      if (response.ok) {
        await refreshCart();
        openCart();
      } else {
        const errorData = await response.json();
        alert(errorData.description || 'Failed to add item to basket');
      }
    } catch (e) {
      console.error('Ajax product add failed:', e);
    }
  };

  // Document onload initializer
  document.addEventListener('DOMContentLoaded', function () {
    // Bind listeners to pre-rendered Liquid items immediately for instant interactivity
    bindDrawerItemEvents();

    refreshCart();

    // Check for inline product add forms
    document.querySelectorAll('[data-product-form-ajax]').forEach(form => {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        window.theme.addProductToCart(this);
      });
    });
  });

})();
